// extracted by mini-css-extract-plugin
export default {"button":"M6edPFu","inactive":"yx8Dgff"};